var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export pad"},[_c('button',{staticClass:"button",on:{"click":_vm.onExportFirestore}},[_vm._v("EXPORT FIRESTORE")])])}
var staticRenderFns = []

export { render, staticRenderFns }